"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = void 0;
const fonts_1 = require("./fonts");
const spacings_1 = require("./spacings");
exports.types = {
    labelEnabled: {
        fontWeight: fonts_1.fonts.weight.fontSemiBold,
        lineHeight: spacings_1.spacings.lineHeight.lineMd,
    },
    labelActive: {
        fontWeight: fonts_1.fonts.weight.fontLight,
        lineHeight: spacings_1.spacings.lineHeight.lineXs,
    },
};
//# sourceMappingURL=types.js.map